import React from "react";

const ChevronUpIcon: React.FC = () => (
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18 15L12 9L6 15"
			stroke="#333"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default ChevronUpIcon;
